import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import loading from '../loading.svg';
import { BASEURI, getAuthToken, handleAuthTokenError } from '../utils';

function StationItem(props) {
    const [adding, setAdding] = useState(false);
    const intl = useIntl();

    useEffect(() => {
        if (!props.addingDevice)
            setAdding(props.addingDevice);
    }, [props.addingDevice])

    const { station, agZoomStations, setAgZoomStations } = props;

    const handleAddStation = () => {
        setAdding(true);
        props.addStation({
            ...station,
            keepOpen: true,
            onSuccess: () => {
                // Update the station's is_added status in the list
                const updatedStations = agZoomStations.map(s => {
                    if (s.serial === station.serial) {
                        return { ...s, is_added: true };
                    }
                    return s;
                });
                setAgZoomStations(updatedStations);
                setAdding(false);
            }
        });
    };

    return <tr className="border-b-[1px]">
        <td className="p-2">{station.name}</td>
        <td className="p-2">{station.serial}</td>
        <td className="p-2">
            {adding ? <img
                title={intl.formatMessage({ id: 'app.stations.stationForm.adding', defaultMessage: 'Adding station please wait.' })}
                className='p-0 m-0'
                style={{ color: 'gray', width: '31px' }}
                src={loading} alt='loading'></img> :
                <>
                    {!station.is_added ?
                        <button className="text-green-500" onClick={handleAddStation}>
                            <i title={intl.formatMessage({ id: 'app.stations.stationForm.addStation', defaultMessage: 'Add station' })}
                                className="material-icons"
                                style={{ 'color': '#7bd47b' }}>add</i>
                        </button> :
                        <i title={intl.formatMessage({ id: 'app.stations.stationForm.alreadyAded', defaultMessage: 'Already added' })}
                            className="material-icons"
                            style={{ 'color': '#7bd47b' }}>check</i>
                    }
                </>}
        </td>
    </tr>
}

function AgZoomStationsList(props) {
    const intl = useIntl();
    const [agZoomStations, setAgZoomStations] = useState([]);
    const [loadingDevices, setLoadingDevices] = useState(false);

    useEffect(() => {
        loadAgZoomStations();
    }, []);

    const loadAgZoomStations = () => {
        setLoadingDevices(true);
        let url = `${BASEURI}/api/ag-zoom/devices/available/`,
            options = {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                }
            };

        getAuthToken()
            .then(token => token)
            .catch(handleAuthTokenError)
            .then(token => {
                options.headers.Authorization = `Bearer ${token}`;

                fetch(url, options)
                    .then((response) => {
                        if (response.status !== 200 && response.status !== 201) {
                            response.text().then(text => console.error(text));
                            throw new Error(response.statusText);
                        }
                        return response.json();
                    })
                    .then((data) => {
                        setLoadingDevices(false);
                        setAgZoomStations(data.devices);
                    })
                    .catch(error => {
                        console.error('Error loading AG-ZOOM devices:', error);
                        setLoadingDevices(false);
                    });
            });
    };

    return (
        <div className="mt-4 rounded-md border-[1px] p-0 text-gray-600">
            <div className="border-b-[1px] p-2 uppercase">
                {intl.formatMessage({ id: 'app.stations.stationForm.agZoomStations', defaultMessage: 'AG-ZOOM Stations List' })}
            </div>
            <table className="m-0 w-full p-0">
                <thead>
                    <tr className="border-b-[1px]">
                        <td className="p-2 capitalize">{intl.formatMessage({ id: 'app.admin.filterMarker.name', defaultMessage: 'Name' })}</td>
                        <td className="p-2 capitalize">{intl.formatMessage({ id: 'app.admin.stationGrid.serial', defaultMessage: 'Serial' })}</td>
                        <td className="p-2 capitalize">{intl.formatMessage({ id: 'app.stations.modelFrom.addStation', defaultMessage: 'Add Station' })}</td>
                    </tr>
                </thead>
                <tbody>
                    {agZoomStations.map((station) => (
                        <StationItem
                            agZoomStations={agZoomStations}
                            setAgZoomStations={setAgZoomStations}
                            key={station.serial}
                            addStation={props.addStation}
                            addingDevice={props.addingDevice}
                            station={station}
                        />
                    ))}
                </tbody>
            </table>
            {loadingDevices ?
                <div className="p-2 text-center text-sm font-light">
                    {intl.formatMessage({ id: 'app.stations.stationForm.loadingAgZoomStations', defaultMessage: 'Loading AG-ZOOM Stations...' })}
                </div> :
                <div className="p-2 text-center text-sm font-light">
                    {intl.formatMessage({ id: 'app.stations.stationForm.total', defaultMessage: 'Total {count} Stations' }, { count: agZoomStations.length })}
                </div>
            }
        </div>
    )
}

export default AgZoomStationsList; 